<template>
	<div id="live-player" class="myCast">
		<audio ref="audioElement" style="display:none;" v-bind:src="player.streamUri" />
		<div class="player-wpr">
			<div class="bg-wpr bg-black">
				<div class="indicator-online" v-if="player.streamInfo.isLive"><span></span> LIVE</div>
				<div v-on:click="toggleSound(player.streamUri)" v-bind:class="playButtonClass"></div>
				<div class="player-ctr">
					<div class="track-info animated"> 
						<div class="track-title ticker animated">{{player.streamInfo.nowPlaying}}</div>
						<div class="artist-name animated">{{player.streamInfo.serverName}}</div>
					</div>
					<div class="controls-wpr animated"> 
						<div class="vol-icon fa vol-icon3"></div>
						<div class="volume-slider-wpr"> 
							<input v-on:change="setPlayerVolume" class="volume-slider" type="range" min="0" max="100" step="0.10" v-model="player.volumeLevel" autocomplete="off"><span class="vol-value">{{player.volumeLevel}}%</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data () {
	return {
		interval: null,
		player: {
			volumeLevel: 95,
			streamUri: "http://emp.cx:8192/;",
			apiStatusUrl: "http://emp.cx/php/shoutcast_json_relay.php",
			isPlaying: false,
			streamInfo: {
				data: null,
				serverName: "EMP Radio",
				nowPlaying: "Electronic Radio",
				isLive: false
			}
		} 
	}
  },
  computed: {
      playerVolume: function() {
          return (this.player.volumeLevel / 100);
	  },
	  playButtonClass: function() {
		  if (this.player.isPlaying) {
			  return "ppBtn stop-btn";
		  } else if (this.player.streamInfo.isLive) {
			  return "ppBtn play-btn button-glow";
		  } 
		  return "ppBtn play-btn";
	  }
  },
  created: function() {
	  this.fetchPlayingInfo();
      this.interval = setInterval(function() { this.fetchPlayingInfo(); }.bind(this), 6000);
  },
  methods: {
    fetchPlayingInfo: function() {
        this.$http.get(this.player.apiStatusUrl).then(response => {
			var data = response.data;
			this.player.streamInfo.data = data;

			if (data.SERVERTITLE) {
				this.player.streamInfo.serverName = data.SERVERTITLE;
			}
			if (data.SONGTITLE) {
				this.player.streamInfo.nowPlaying = data.SONGTITLE;
			}
			if (data.ISLIVE) {
				this.player.streamInfo.isLive = true;
			} else {
				this.player.streamInfo.isLive = false;
			}
			
        }).catch(err => {
			this.player.streamInfo.isLive = false;
			this.player.streamInfo.serverName = "EMP Radio";
			this.player.streamInfo.nowPlaying = "Electronic Radio";
            this.player.streamInfo.data = null;
        })
    },
    toggleSound: function() {
        if (this.player.isPlaying) {
            this.$refs.audioElement.pause();
            this.$refs.audioElement.load();
            this.player.isPlaying = false;
        } else {
            this.$refs.audioElement.load();
            this.$refs.audioElement.play();
            this.player.isPlaying = true;
        }
    },
    setPlayerVolume: function() {
        this.$refs.audioElement.volume = this.playerVolume;
    }
  },
  beforeDestory() {
      clearInterval(this.interval);
  }
}
</script>

<style>

#live-player {
	width: 100%;
}

.indicator-online {
	position: absolute;
	bottom: 10px;
	right: 10px;
	font-size: 1em;
	color: #ffffff;
	z-index: 9999;
}

.indicator-online span {
    background: #28B62C;
    display: inline-block;
	margin-right: 5px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
  	box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #28B62C 0 2px 12px;
    -webkit-animation: pulse-animation 2s infinite linear;
}

@-webkit-keyframes pulse-animation {
	0% { -webkit-transform: scale(1); }
	25% { -webkit-transform: scale(1); }
    50% { -webkit-transform: scale(1.1) }
    75% { -webkit-transform: scale(1); }
    100% { -webkit-transform: scale(1); }
}



@media (min-width: 576px) {
	#live-player {
		max-width: 540px;
	}
}

@media (min-width: 768px) {
	#live-player {
		max-width: 720px;
	}
}

@media (min-width: 992px) {
	#live-player {
		max-width: 960px;
	}
}

@media (min-width: 1200px) {
	#live-player {
		max-width: 1140px;
	}
}



@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700,900');

.myCast .player-wpr {
	height: 80px;
	font-family: 'Roboto', Arial, sans-serif;
	font-weight: 400;	
	text-align: left;
	color: rgba(0,0,0,.87);
	position: relative;
	overflow: hidden;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeLegibility;
}
.myCast .bg-wpr {
	width: 100%;
	height: 80px;	
	background: #f5f5f5;
	overflow: hidden;
	z-index: 100;
}
.myCast .player-ctr {	
	height: 80px;
	position: relative;
	overflow: hidden;	
	z-index: 101;
}
.myCast .blur {
	width: 100%;
	height: 80px;
	position: absolute;		
	opacity: 0;
	display: none;
	-webkit-transform: scale(1.5);
	-moz-transform: scale(1.5);
	-ms-transform: scale(1.5);
	-o-transform: scale(1.5);
	transform: scale(1.5);
	z-index: 100;
}

.myCast .track-info {
	position: relative;
	padding-left: 80px;
	padding-right: 56px;
	padding-top: 2px;	
	z-index: 104;
	animation-duration: 2s;
}
.myCast .track-title {
	font-size: 16px;
	color: rgba(0,0,0,1);
	overflow: hidden;
	text-overflow: ellipsis;	
	white-space: nowrap;
}
.myCast .artist-name {
	font-size: 12px;
	color: rgba(0,0,0,.54);
	overflow: hidden;
	text-overflow: ellipsis;	
	white-space: nowrap;
	
}
.myCast .ppBtn {
	width: 40px;
	height: 40px;		
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 54px 54px;
	font-size: 16px;
	text-align: center;
	position: absolute;
	left: 16px;
	bottom: 16px;
	border-radius: 50%;	
	-webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.13), 0 3px 6px rgba(0,0,0,0.19);	
	-moz-box-shadow: 0 3px 6px rgba(0,0,0,0.13), 0 3px 6px rgba(0,0,0,0.19);	
	box-shadow: 0 3px 6px rgba(0,0,0,0.13), 0 3px 6px rgba(0,0,0,0.19);	
	cursor: pointer;
	z-index: 400;
}
.myCast .play-btn {		
	color: rgba(0,0,0,1);
	background: #FF5722 url(../assets/img/playw.svg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 26px 26px;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s; 
    transition: all 0.5s;
}

@keyframes glowing {
  0% { box-shadow: 0 0 -10px #ffffff59; }
  40% { box-shadow: 0 0 20px #ffffff59; }
  60% { box-shadow: 0 0 20px #ffffff59; }
  100% { box-shadow: 0 0 -10px #ffffff59; }
}

.button-glow {
  animation: glowing 4000ms infinite;
}

.myCast .stop-btn {		
	color: rgba(0,0,0,1);
	background: #FF5722 url(../assets/img/pausew.svg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 26px 26px;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s; 
    transition: all 0.5s;
}
.myCast .play-btn:hover,
.myCast .stop-btn:hover {
	background-color: #F4511E;	
}
.myCast .controls-wpr {
	height: 36px;
	background: rgba(255,255,255,1);
	text-align: left;	
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding-top: 2px;
	padding-left: 80px;
	padding-right: 46px;	
	z-index: 101;
}
.myCast .volume-slider-wpr {
	padding-left: 25px;
	padding-right: 60px;
}
.myCast .volume-slider {
	display: inline-block;
}
.myCast .vol-value {
	width: 36px;
	font-size: 11px;
	line-height: 38px;
	text-align: center;
	position: relative;
	margin-left: 0px;
	vertical-align: top;
	display: inline-block;	
}
.myCast .vol-icon {
	width: 16px;
	height: 16px;
	line-height: 16px;
	position: absolute;
	top: 8px;
	font-size: 20px;
	color: rgba(0,0,0,.87);
}
.myCast .vol-icon1::before {
	content: "\f026";
}
.myCast .vol-icon2::before {
	content: "\f027";
}
.myCast .vol-icon3::before {
	content: "\f028";
}
.myCast input[type=range] {
	width: 100px;
	height: 6px;
	background: none;
	margin-top: 5px;
	padding: 10px 0px 10px 0px;
	-webkit-appearance: none;
	cursor: pointer;
}
.myCast input[type=range]:focus {
  outline: none;
}
.myCast input[type=range]::-webkit-slider-runnable-track {
	width: 100%;
	height: 6px;
	background: rgba(0,0,0,.14);
	padding: 0;
	margin: 0;
	border: 0;
	border-radius: 8px;
	cursor: pointer;	
	animate: 0.2s;
}
.myCast input[type=range]:focus::-webkit-slider-runnable-track {
	background: rgba(0,0,0,.14);
}
.myCast input[type=range]::-webkit-slider-thumb {
	width: 12px;
	height: 12px;
	background: #FF5314;
	margin-top: -3px;
	border-radius: 50%;	
	cursor: pointer;
	-webkit-appearance: none;
}
.myCast input[type=range]:hover::-webkit-slider-thumb {
	margin-top: -3px;
	-webkit-appearance: none;
	transform: scale(1.3);
}
.myCast input[type=range]::-moz-range-track {
	width: 100%;
	height: 6px;
	background: rgba(0,0,0,0.14);
	padding: 0;
	margin: 0;
	border: 0px;
	border-radius: 8px;
	cursor: pointer;
	animate: 0.2s; 
}
.myCast input[type=range]::-moz-range-thumb {
	width: 12px;
	height: 12px;
	background: #FF5314;
	border: 0;
	border-radius: 50%;
	cursor: pointer;
}
.myCast input[type=range]:hover::-moz-range-thumb {
	transform: scale(1.3);
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.myCast input[type=range] {
		width: 100px;
		height: 16px;
		background: none;
		margin-top: 0px;
		padding: 10px 0px 10px 0px; 
		cursor: pointer;
	}
}
.myCast input[type=range]::-ms-tooltip {
	display: none; 
}
.myCast input[type=range]::-ms-track {
	width: 100%;
	height: 6px;
	background: transparent;
	border-color: transparent;
	color: transparent;
	cursor: pointer;
	animate: 0.2s;  
}
.myCast input[type=range]::-ms-fill-lower {
	background: rgba(0,0,0,0.14);
	border: 0px;
	border-radius: 15px;
}
.myCast input[type=range]::-ms-fill-upper {
	background: rgba(0,0,0,0.14);
	border: 0px;
	border-radius: 8px;
}
.myCast input[type=range]::-ms-thumb {
	width: 14px;
	height: 14px;
	background: #FF5314;
	border: 0px;  
	border-radius: 50%;  
	cursor: pointer;
}
.myCast input[type=range]:focus::-ms-fill-lower {
	background: transparent;
}
.myCast input[type=range]:focus::-ms-fill-upper {
	background: transparent;
}


@media (min-height: 400px) {
	.myCast .player-wpr,
	.myCast .player-ctr,
	.myCast .bg-wpr,
	.myCast .blur {
		height: 120px;
	}

	.myCast .blur {
		height: 120px;
		-webkit-transform: scale(1.5);
		-moz-transform: scale(1.5);
		-ms-transform: scale(1.5);
		-o-transform: scale(1.5);
		transform: scale(1.5);
	}
	.myCast .track-info {
		padding-left: 120px;
		padding-right: 30px;
		padding-top: 10px;
	}
	.myCast .track-title {
		font-size: 18px;
	}
	.myCast .artist-name {
		font-size: 14px;
	}
	.myCast .ppBtn {
		width: 80px;
		height: 80px;
		left: 14px;
		bottom: 14px;
	}
	.myCast .play-btn {		
		color: rgba(0,0,0,1);
		background: #FF5722 url(../assets/img/playw.svg);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 40px 40px;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s; 
		transition: all 0.5s;
	}
	.myCast .stop-btn {		
		color: rgba(0,0,0,1);
		background: #FF5722 url(../assets/img/pausew.svg);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 40px 40px;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s; 
		transition: all 0.5s;
	}
	.myCast .controls-wpr {
		height: 50px;
		padding-top: 12px;
		padding-left: 120px;
		padding-right: 32px;
	}
	.myCast .volume-slider-wpr {
		padding-left: 20px;
		padding-right: 60px;
	}
	.myCast .volume-slider {
		display: inline-block;
	}
	.myCast .vol-value {
		width: 10%;
		font-size: 18px;
		line-height: 28px;
		margin-left: 2px;
		padding-top: 1px;
	}
	.myCast .vol-icon {
		width: 16px;
		height: 16px;
		line-height: 16px;
		top: 16px;
		font-size: 15px;
	}
}

@media (min-height: 900px) {
	.myCast .player-wpr,
	.myCast .player-ctr,
	.myCast .bg-wpr,
	.myCast .blur {
		height: 180px;
	}

	
	.myCast .blur {
		height: 120px;
		-webkit-transform: scale(1.5);
		-moz-transform: scale(1.5);
		-ms-transform: scale(1.5);
		-o-transform: scale(1.5);
		transform: scale(1.5);
	}
	.myCast .track-info {
		padding-left: 160px;
		padding-right: 30px;
		padding-top: 10px;
	}
	.myCast .track-title {
		font-size: 28px;
	}
	.myCast .artist-name {
		font-size: 24px;
	}
	.myCast .ppBtn {
		width: 120px;
		height: 120px;
		left: 20px;
		bottom: 16px;
	}
	.myCast .play-btn {		
		color: rgba(0,0,0,1);
		background: #FF5722 url(../assets/img/playw.svg);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 80px 80px;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s; 
		transition: all 0.5s;
	}

	.myCast .stop-btn {		
		color: rgba(0,0,0,1);
		background: #FF5722 url(../assets/img/pausew.svg);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 80px 80px;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s; 
		transition: all 0.5s;
	}
	.myCast .controls-wpr {
		height: 74px;
		padding-top: 22px;
		padding-left: 160px;
		padding-right: 42px;
	}
	.myCast .volume-slider-wpr {
		padding-left: 20px;
		padding-right: 80px;
	}
	.myCast .volume-slider {
		display: inline-block;
	}
	.myCast .vol-value {
		width: 10%;
		font-size: 18px;
		line-height: 28px;
		margin-left: 2px;
		padding-top: 1px;
	}
	.myCast .vol-icon {
		width: 16px;
		height: 16px;
		line-height: 16px;
		top: 28px;
		font-size: 15px;
	}
}






/* Helper Clases */
.myCast .valign-middle {
	padding-bottom: 2px;
	vertical-align: middle;
}
.myCast .rounded {
	border-radius: 5px;
}
.myCast .dis-none {
	display: none;
}
.myCast .vol-dis {
	opacity: 0.35;
}
.myCast .hidden {
	visibility: hidden;
}
.myCast .visible {
	display: block;
}

/* Player Backgrounds */
.myCast .bg-red {
	background: #bf2026;
}
.myCast .bg-pink {
	background: #E91E63;
}
.myCast .bg-purple {
	background: #9C27B0;
}
.myCast .bg-deeppurple {
	background: #673AB7;
}
.myCast .bg-indigo {
	background: #3F51B5;
}
.myCast .bg-blue {
	background: #2196F3;
}
.myCast .bg-lightblue {
	background: #03A9F4;
}
.myCast .bg-cyan {
	background: #00BCD4;
}
.myCast .bg-teal {
	background: #009688;
}
.myCast .bg-green {
	background: #4CAF50;
}
.myCast .bg-lightgreen {
	background: #8BC34A;
}
.myCast .bg-lime {
	background: #CDDC39;
}
.myCast .bg-yellow {
	background: #FFEB3B;
}
.myCast .bg-amber {
	background: #FFC107;
}
.myCast .bg-orange {
	background: #FF9800;
}
.myCast .bg-deeporange {
	background: #FF5722;
}
.myCast .bg-brown {
	background: #795548;
}
.myCast .bg-grey {
	background: #BDBDBD;
}
.myCast .bg-bluegrey {
	background: #607D8B;
}
.myCast .bg-darkblue {
	background: #163372;
}
.myCast .bg-black {
  background:rgba(94, 94, 94, 0.95);
}
.myCast .bg-white {
	background: #F5F5F5;
}

/* Text Colors */
.bg-red .track-title, .bg-pink .track-title, .bg-purple .track-title, .bg-deeppurple .track-title, .bg-indigo .track-title, .bg-blue .track-title, .bg-teal .track-title, .bg-deeporange .track-title, .bg-brown .track-title, .bg-bluegrey .track-title, .bg-black .track-title, .bg-darkblue .track-title {
	color: rgba(255,255,255,1);
}
.bg-lightblue .track-title, .bg-cyan .track-title, .bg-green .track-title, .bg-lightgreen .track-title, .bg-lime .track-title, .bg-yellow .track-title, .bg-amber .track-title, .bg-orange .track-title, .bg-grey .track-title, .bg-white .track-title {
	color: rgba(0,0,0,.87);
}
.bg-lightblue .artist-name, .bg-cyan .artist-name, .bg-green .artist-name, .bg-lightgreen .artist-name, .bg-lime .artist-name,  .bg-yellow .artist-name, .bg-amber .artist-name, .bg-orange .artist-name, .bg-grey .artist-name, .bg-white .artist-name {
	color: rgba(0,0,0,0.54);
}
.bg-red .artist-name, .bg-pink .artist-name, .bg-purple .artist-name, .bg-deeppurple .artist-name, .bg-indigo .artist-name, .bg-blue .artist-name, .bg-teal .artist-name, .bg-deeporange .artist-name, .bg-brown .artist-name, .bg-bluegrey .artist-name, .bg-black .artist-name, .bg-darkblue .artist-name {
	color: rgba(255,255,255,.7);
}
.bg-red .vol-value, .bg-pink .vol-value, .bg-purple .vol-value, .bg-deeppurple .vol-value, .bg-indigo .vol-value, .bg-blue .vol-value, .bg-teal .vol-value, .bg-deeporange .vol-value, .bg-brown .vol-value, .bg-bluegrey .vol-value, .bg-darkblue .vol-value, .bg-black .vol-value {
	color: rgba(255,255,255,.54);
}
.bg-lightblue .vol-value, .bg-cyan .vol-value, .bg-green .vol-value, .bg-lightgreen .vol-value, .bg-lime .vol-value, .bg-yellow .vol-value, .bg-amber .vol-value, .bg-orange .vol-value, .bg-grey .vol-value, .bg-white .vol-value {
	color: rgba(0,0,0,.48);
}

/* Play/Pause Color */

.accent-red .play-btn {
	background: #bf2026 url(../assets/img/playw.svg);	
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 54px 54px;
}

.accent-red .stop-btn {
	background: #bf2026 url(../assets/img/pausew.svg);	
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 54px 54px;
}

.accent-red .play-btn:hover,
.accent-red .stop-btn:hover {
	background-color: #E53935;
}
.accent-red .play-btn {
	background-position: center center;
	background-repeat: no-repeat;
}
.accent-red .stop-btn {
	background-position: center center;
	background-repeat: no-repeat;
}

/* Volume Slider Panel & Data Panel Bg */
.bg-red .controls-wpr,
.bg-red .data-panel-info {
	background: rgba(0,0,0,0.07);
}
.bg-pink .controls-wpr,
.bg-pink .data-panel-info {
	background: rgba(0,0,0,0.07);
}
.bg-purple .controls-wpr,
.bg-purple .data-panel-info {
	background: rgba(0,0,0,0.07);
}
.bg-deeppurple .controls-wpr,
.bg-deeppurple .data-panel-info {
	background: rgba(0,0,0,0.08);
}
.bg-indigo .controls-wpr,
.bg-indigo .data-panel-info {
	background: rgba(0,0,0,0.09);
}
.bg-blue .controls-wpr,
.bg-blue .data-panel-info {
	background: rgba(0,0,0,0.09);
}
.bg-lightblue .controls-wpr,
.bg-lightblue .data-panel-info {
	background: rgba(255,255,255,0.14);
}
.bg-cyan .controls-wpr,
.bg-cyan .data-panel-info {
	background: rgba(255,255,255,0.14);
}
.bg-teal .controls-wpr,
.bg-teal .data-panel-info {
	background: rgba(0,0,0,0.09);
}
.bg-green .controls-wpr,
.bg-green .data-panel-info {
	background: rgba(255,255,255,0.14);
}
.bg-lightgreen .controls-wpr,
.bg-lightgreen .data-panel-info {
	background: rgba(255,255,255,0.14);
}
.bg-lime .controls-wpr,
.bg-lime .data-panel-info {
	background: rgba(255,255,255,0.14);
}
.bg-yellow .controls-wpr,
.bg-yellow .data-panel-info {
	background: rgba(255,255,255,0.25);
}
.bg-amber .controls-wpr,
.bg-amber .data-panel-info {
	background: rgba(255,255,255,0.32);
}
.bg-orange .controls-wpr,
.bg-orange .data-panel-info {
	background: rgba(255,255,255,0.16);
}
.bg-deeporange .controls-wpr,
.bg-deeporange .data-panel-info {
	background: rgba(0,0,0,0.05);
}
.bg-brown .controls-wpr,
.bg-brown .data-panel-info {
	background: rgba(0,0,0,0.09);
}
.bg-grey .controls-wpr,
.bg-grey .data-panel-info {
	background: rgba(255,255,255,0.2);
}
.bg-lightgrey .controls-wpr,
.bg-lightgrey .data-panel-info {
	background: rgba(255,255,255,0.2);
}
.bg-bluegrey .controls-wpr,
.bg-bluegrey .data-panel-info {
	background: rgba(0,0,0,0.11);
}
.bg-darkblue .controls-wpr,
.bg-darkblue .data-panel-info {
	background: rgba(0,0,0,0.16);
}
.bg-black .controls-wpr,
.bg-black .data-panel-info {
	background: rgba(0,0,0,0.4);
}
.bg-white .controls-wpr,
.bg-white .data-panel-info {
	background: rgba(255,255,255,1);
}

/* Volume Icon Color */
.bg-red .vol-icon,
.bg-pink .vol-icon,
.bg-purple .vol-icon,
.bg-deeppurple .vol-icon,
.bg-indigo .vol-icon,
.bg-blue .vol-icon,
.bg-teal .vol-icon,
.bg-deeporange .vol-icon,
.bg-brown .vol-icon,
.bg-bluegrey .vol-icon,
.bg-darkblue .vol-icon,
.bg-black .vol-icon {
	color: rgba(255,255,255,.95);
}

/* Volume Slider Opacity */
.myCast .bg-red input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-pink input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-deeporange input[type=range]::-webkit-slider-runnable-track  {
	background: rgba(255,255,255,.4);
}
.myCast .bg-purple input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-deeppurple input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-indigo input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-blue input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-teal input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-brown input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-bluegrey input[type=range]::-webkit-slider-runnable-track {
	background: rgba(255,255,255,.36);
}
.myCast .bg-lightblue input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-cyan input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-green input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-lightgreen input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-lime input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-grey input[type=range]::-webkit-slider-runnable-track {
	background: rgba(0,0,0,.18);
}
.myCast .bg-yellow input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-amber input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-orange input[type=range]::-webkit-slider-runnable-track {
	background: rgba(0,0,0,.12);
}
.myCast .bg-black input[type=range]::-webkit-slider-runnable-track,
.myCast .bg-darkblue input[type=range]::-webkit-slider-runnable-track {
	background: rgba(255,255,255,.3);
}
.myCast .bg-white input[type=range]::-webkit-slider-runnable-track {
	background: rgba(0,0,0,.14);
}
.myCast .bg-red input[type=range]::-moz-range-track,
.myCast .bg-pink input[type=range]::-moz-range-track,
.myCast .bg-deeporange input[type=range]::-moz-range-track  {
	background: rgba(255,255,255,.4);
}
.myCast .bg-purple input[type=range]::-moz-range-track,
.myCast .bg-deeppurple input[type=range]::-moz-range-track,
.myCast .bg-indigo input[type=range]::-moz-range-track,
.myCast .bg-blue input[type=range]::-moz-range-track,
.myCast .bg-teal input[type=range]::-moz-range-track,
.myCast .bg-brown input[type=range]::-moz-range-track,
.myCast .bg-bluegrey input[type=range]::-moz-range-track {
	background: rgba(255,255,255,.36);
}
.myCast .bg-lightblue input[type=range]::-moz-range-track,
.myCast .bg-cyan input[type=range]::-moz-range-track,
.myCast .bg-green input[type=range]::-moz-range-track,
.myCast .bg-lightgreen input[type=range]::-moz-range-track,
.myCast .bg-lime input[type=range]::-moz-range-track,
.myCast .bg-grey input[type=range]::-moz-range-track {
	background: rgba(0,0,0,.18);
}
.myCast .bg-yellow input[type=range]::-moz-range-track,
.myCast .bg-amber input[type=range]::-moz-range-track,
.myCast .bg-orange input[type=range]::-moz-range-track {
	background: rgba(0,0,0,.12);
}
.myCast .bg-black input[type=range]::-moz-range-track,
.myCast .bg-darkblue input[type=range]::-moz-range-track {
	background: rgba(255,255,255,.3);
}
.myCast .bg-white input[type=range]::-moz-range-track {
	background: rgba(0,0,0,.14);
}
.myCast .bg-purple input[type=range]::-ms-fill-lower,
.myCast .bg-deeppurple input[type=range]::-ms-fill-lower,
.myCast .bg-indigo input[type=range]::-ms-fill-lower,
.myCast .bg-blue input[type=range]::-ms-fill-lower,
.myCast .bg-teal input[type=range]::-ms-fill-lower,
.myCast .bg-brown input[type=range]::-ms-fill-lower,
.myCast .bg-bluegrey input[type=range]::-ms-fill-lower {
	background: rgba(255,255,255,.36);
}
.myCast .bg-lightblue input[type=range]::-ms-fill-lower,
.myCast .bg-cyan input[type=range]::-ms-fill-lower,
.myCast .bg-green input[type=range]::-ms-fill-lower,
.myCast .bg-lightgreen input[type=range]::-ms-fill-lower,
.myCast .bg-lime input[type=range]::-ms-fill-lower,
.myCast .bg-grey input[type=range]::-ms-fill-lower {
	background: rgba(0,0,0,.18);
}
.myCast .bg-yellow input[type=range]::-ms-fill-lower,
.myCast .bg-amber input[type=range]::-ms-fill-lower,
.myCast .bg-orange input[type=range]::-ms-fill-lower {
	background: rgba(0,0,0,.12);
}
.myCast .bg-black input[type=range]::-ms-fill-lower,
.myCast .bg-darkblue input[type=range]::-ms-fill-lower {
	background: rgba(255,255,255,.3);
}
.myCast .bg-white input[type=range]::-ms-fill-lower {
	background: rgba(0,0,0,.14);
}
.myCast .bg-purple input[type=range]::-ms-fill-upper,
.myCast .bg-deeppurple input[type=range]::-ms-fill-upper,
.myCast .bg-indigo input[type=range]::-ms-fill-upper,
.myCast .bg-blue input[type=range]::-ms-fill-upper,
.myCast .bg-teal input[type=range]::-ms-fill-upper,
.myCast .bg-brown input[type=range]::-ms-fill-upper,
.myCast .bg-bluegrey input[type=range]::-ms-fill-upper {
	background: rgba(255,255,255,.36);
}
.myCast .bg-lightblue input[type=range]::-ms-fill-upper,
.myCast .bg-cyan input[type=range]::-ms-fill-upper,
.myCast .bg-green input[type=range]::-ms-fill-upper,
.myCast .bg-lightgreen input[type=range]::-ms-fill-upper,
.myCast .bg-lime input[type=range]::-ms-fill-upper,
.myCast .bg-grey input[type=range]::-ms-fill-upper {
	background: rgba(0,0,0,.18);
}
.myCast .bg-yellow input[type=range]::-ms-fill-upper,
.myCast .bg-amber input[type=range]::-ms-fill-upper,
.myCast .bg-orange input[type=range]::-ms-fill-upper {
	background: rgba(0,0,0,.12);
}
.myCast .bg-black input[type=range]::-ms-fill-upper,
.myCast .bg-darkblue input[type=range]::-ms-fill-upper {
	background: rgba(255,255,255,.3);
}
.myCast .bg-white input[type=range]::-ms-fill-upper {
	background: rgba(0,0,0,.14);
}

/* Volume Slider Thumb Color */
.accent-red input[type=range]::-webkit-slider-thumb {
	background: #bf2026;
}
.accent-red input[type=range]::-moz-range-thumb {
	background: #bf2026;
}
.accent-red input[type=range]::-ms-thumb {
	background: #bf2026;
}
.accent-pink input[type=range]::-webkit-slider-thumb {
	background: #E91E63;
}
.accent-pink input[type=range]::-moz-range-thumb {
	background: #E91E63;
}
.accent-pink input[type=range]::-ms-thumb {
	background: #E91E63;
}
.accent-purple input[type=range]::-webkit-slider-thumb {
	background: #9C27B0;
}
.accent-purple input[type=range]::-moz-range-thumb {
	background: #9C27B0;
}
.accent-purple input[type=range]::-ms-thumb {
	background: #9C27B0;
}
.accent-deeppurple input[type=range]::-webkit-slider-thumb {
	background: #673AB7;
}
.accent-deeppurple input[type=range]::-moz-range-thumb {
	background: #673AB7;
}
.accent-deeppurple input[type=range]::-ms-thumb {
	background: #673AB7;
}
.accent-indigo input[type=range]::-webkit-slider-thumb {
	background: #3F51B5;
}
.accent-indigo input[type=range]::-moz-range-thumb {
	background: #3F51B5;
}
.accent-indigo input[type=range]::-ms-thumb {
	background: #3F51B5;
}
.accent-blue input[type=range]::-webkit-slider-thumb {
	background: #2196F3;
}
.accent-blue input[type=range]::-moz-range-thumb {
	background: #2196F3;
}
.accent-blue input[type=range]::-ms-thumb {
	background: #2196F3;
}
.accent-lightblue input[type=range]::-webkit-slider-thumb {
	background: #03A9F4;
}
.accent-lightblue input[type=range]::-moz-range-thumb {
	background: #03A9F4;
}
.accent-lightblue input[type=range]::-ms-thumb {
	background: #03A9F4;
}
.accent-cyan input[type=range]::-webkit-slider-thumb {
	background: #00BCD4;
}
.accent-cyan input[type=range]::-moz-range-thumb {
	background: #00BCD4;
}
.accent-cyan input[type=range]::-ms-thumb {
	background: #00BCD4;
}
.accent-teal input[type=range]::-webkit-slider-thumb {
	background: #009688;
}
.accent-teal input[type=range]::-moz-range-thumb {
	background: #009688;
}
.accent-teal input[type=range]::-ms-thumb {
	background: #009688;
}
.accent-green input[type=range]::-webkit-slider-thumb {
	background: #4CAF50;
}
.accent-green input[type=range]::-moz-range-thumb {
	background: #4CAF50;
}
.accent-green input[type=range]::-ms-thumb {
	background: #4CAF50;
}
.accent-lightgreen input[type=range]::-webkit-slider-thumb {
	background: #8BC34A;
}
.accent-lightgreen input[type=range]::-moz-range-thumb {
	background: #8BC34A;
}
.accent-lightgreen input[type=range]::-ms-thumb {
	background: #8BC34A;
}
.accent-lime input[type=range]::-webkit-slider-thumb {
	background: #CDDC39;
}
.accent-lime input[type=range]::-moz-range-thumb {
	background: #CDDC39;
}
.accent-lime input[type=range]::-ms-thumb {
	background: #CDDC39;
}
.accent-yellow input[type=range]::-webkit-slider-thumb {
	background: #FFEB3B;
}
.accent-yellow input[type=range]::-moz-range-thumb {
	background: #FFEB3B;
}
.accent-yellow input[type=range]::-ms-thumb {
	background: #FFEB3B;
}
.accent-amber input[type=range]::-webkit-slider-thumb {
	background: #FFC107;
}
.accent-amber input[type=range]::-moz-range-thumb {
	background: #FFC107;
}
.accent-amber input[type=range]::-ms-thumb {
	background: #FFC107;
}
.accent-orange input[type=range]::-webkit-slider-thumb {
	background: #FF9800;
}
.accent-orange input[type=range]::-moz-range-thumb {
	background: #FF9800;
}
.accent-orange input[type=range]::-ms-thumb {
	background: #FF9800;
}
.accent-deeporange input[type=range]::-webkit-slider-thumb {
	background: #FF5722;
}
.accent-deeporange input[type=range]::-moz-range-thumb {
	background: #FF5722;
}
.accent-deeporange input[type=range]::-ms-thumb {
	background: #FF5722;
}
.accent-brown input[type=range]::-webkit-slider-thumb {
	background: #795548;
}
.accent-brown input[type=range]::-moz-range-thumb {
	background: #795548;
}
.accent-brown input[type=range]::-ms-thumb {
	background: #795548;
}
.accent-grey input[type=range]::-webkit-slider-thumb {
	background: #BDBDBD;
}
.accent-grey input[type=range]::-moz-range-thumb {
	background: #BDBDBD;
}
.accent-grey input[type=range]::-ms-thumb {
	background: #BDBDBD;
}
.accent-bluegrey input[type=range]::-webkit-slider-thumb {
	background: #607D8B;
}
.accent-bluegrey input[type=range]::-moz-range-thumb {
	background: #607D8B;
}
.accent-bluegrey input[type=range]::-ms-thumb {
	background: #607D8B;
}
.accent-darkblue input[type=range]::-webkit-slider-thumb {
	background: #163372;
}
.accent-darkblue input[type=range]::-moz-range-thumb {
	background: #163372;
}
.accent-darkblue input[type=range]::-ms-thumb {
	background: #163372;
}
.accent-black input[type=range]::-webkit-slider-thumb {
	background: #262626;
}
.accent-black input[type=range]::-moz-range-thumb {
	background: #262626;
}
.accent-black input[type=range]::-ms-thumb {
	background: #262626;
}

/* More Icon Color */
.bg-red .more,
.bg-pink .more,
.bg-purple .more,
.bg-deeppurple .more,
.bg-indigo .more,
.bg-blue .more,
.bg-teal .more,
.bg-deeporange .more,
.bg-brown .more,
.bg-bluegrey .more,
.bg-darkblue .more,
.bg-black .more {
	color: rgba(255,255,255,.95);
}

/* Data Panel Text Color */
.bg-red .data-panel-info,
.bg-pink .data-panel-info,
.bg-purple .data-panel-info,
.bg-deeppurple .data-panel-info,
.bg-indigo .data-panel-info,
.bg-blue .data-panel-info,
.bg-teal .data-panel-info,
.bg-deeporange .data-panel-info,
.bg-brown .data-panel-info,
.bg-bluegrey .data-panel-info,
.bg-darkblue .data-panel-info,
.bg-black .data-panel-info {
	color: rgba(255,255,255,.7);
}

/* Data Chip Icon Bg */
.bg-red .data-panel-r-icon {
	background: #D32F2F;
}
.bg-pink .data-panel-r-icon {
	background: #C2185B;
}
.bg-purple .data-panel-r-icon {
	background: #7B1FA2;
}
.bg-deeppurple .data-panel-r-icon {
	background: #512DA8;
}
.bg-indigo .data-panel-r-icon {
	background: #303F9F;
}
.bg-blue .data-panel-r-icon {
	background: #1976D2;
}
.bg-lightblue .data-panel-r-icon {
	background: #4FC3F7;
}
.bg-cyan .data-panel-r-icon {
	background: #4DD0E1;
}
.bg-teal .data-panel-r-icon {
	background: #00796B;
}
.bg-green .data-panel-r-icon {
	background: #81C784;
}
.bg-lightgreen .data-panel-r-icon {
	background: #AED581;
}
.bg-lime .data-panel-r-icon {
	background: #DCE775;
}
.bg-yellow .data-panel-r-icon {
	background: #FFF59D;
}
.bg-amber .data-panel-r-icon {
	background: #FFE082;
}
.bg-orange .data-panel-r-icon {
	background: #FFB74D;
}
.bg-deeporange .data-panel-r-icon {
	background: #E64A19;
}
.bg-brown .data-panel-r-icon {
	background: #5D4037;
}
.bg-grey .data-panel-r-icon {
	background: #9E9E9E;
}
.bg-bluegrey .data-panel-r-icon {
	background: #455A64;
}
.bg-darkblue .data-panel-r-icon {
	background: #09193E;
}
.bg-black .data-panel-r-icon {
	background: #101010;
}

/* Data Panel Chip Icon Color*/
.bg-red .data-panel-r-icon,
.bg-pink .data-panel-r-icon,
.bg-purple .data-panel-r-icon,
.bg-deeppurple .data-panel-r-icon,
.bg-indigo .data-panel-r-icon,
.bg-blue .data-panel-r-icon,
.bg-teal .data-panel-r-icon,
.bg-deeporange .data-panel-r-icon,
.bg-brown .data-panel-r-icon,
.bg-bluegrey .data-panel-r-icon,
.bg-darkblue .data-panel-r-icon,
.bg-black .data-panel-r-icon {
	color: rgba(255,255,255,.84);
}

/* Animations */
.animated {
	animation-duration: 1s;
	animation-fill-mode: both;
}
.lightSpeedIn {
	animation-name: lightSpeedIn;
	animation-timing-function: ease-out;
}
@keyframes lightSpeedIn {
	from {
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0;
	}

	60% {
		transform: skewX(20deg);
		opacity: 1;
	}

	80% {
		transform: skewX(-5deg);
		opacity: 1;
	}

	to {
		transform: none;
		opacity: 1;
	}
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
@keyframes ticker {
	0%   {margin-top: 0}
	15%  {margin-top: -15px}
	30%  {margin-top: -30px}
	45%  {margin-top: -45px}
	60%  {margin-top: -60px}
	75%  {margin-top: -75px}
	90%  {margin-top: -90px}	
}
</style>


// WEBPACK FOOTER //
// src/components/Player.vue